var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-enter-cta-circles"},[_c('ul',{staticClass:"c-enter-cta-circles__list"},_vm._l((3),function(index){return _c('enter-cta-circles-item',{key:index,attrs:{"index-circle":index}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }